import styled, { css } from 'styled-components';

interface IProps {
  posicao?: any;
  lenght: number;
  loading: boolean;
  playlist?: boolean;
}

export const Container = styled.div<IProps>`
  .infinite-scroll-component {
    display: flex;
    flex-wrap: wrap;
    gap: 30px;
    justify-content: flex-start;
  }
  ${(props) =>
    props.posicao === 'lateral' &&
    css`
      grid-template-columns: 1fr;
    `}

  width: 100%;

  grid-gap: ${(props) => (props.posicao === 'lateral' ? '10px' : '31px')};

  ${(props) =>
    props.playlist &&
    css`
      width: 100%;
    `}
  @media (max-width: 800px) {
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  }

  .empty-posts {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
      width: 300px;
    }
  }
  @media (max-width: 800px) {
    display: flex;
    flex-direction: column;
  }

  .loadWrapper {
    width: 100%;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
